import clsx from 'clsx';
import { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Gender, genderOptionTitles } from '@vestico/model';

import { GlobalsContext } from '../CommonAppContext';
import { Dropdown, DropdownOption } from './Dropdown';
import style from './genderIdentityPicker.module.css';

export interface GenderIdentityPickerProps {
  gender: Gender;
  didUpdateGender: (gender: Gender) => void;
}

export const GenderIdentityPicker = ({ gender, didUpdateGender }: GenderIdentityPickerProps) => {
  const { useMobileLayout } = useContext(GlobalsContext);
  const { t } = useTranslation('shared');
  const genderSelectDidUpate = useCallback(
    (index: number) => {
      didUpdateGender(index);
    },
    [didUpdateGender]
  );

  const genderOptions: DropdownOption[] = useMemo(() => {
    return genderOptionTitles().map((title) => {
      return {
        content: title,
      };
    });
  }, []);

  return (
    <div className={clsx(style.root)}>
      <div className={clsx(style.title)}>{t('LOC_IDENTITY_OPTIONS_TITLE')}</div>
      <div className={clsx(style.dropDownWrapper)}>
        <Dropdown
          options={genderOptions}
          selectedOptionIndex={gender.valueOf()}
          didUpdateOption={genderSelectDidUpate}
          textColor="var(--color-text)"
          borderColor="var(--color-input-outline)"
          minWidth={145}
          paddingLeft={useMobileLayout ? undefined : 13}
        />
      </div>
    </div>
  );
};
